import React from 'react'
import { Skeleton, LayoutBand, Row, colors, Grid, Card, Separator, usePageWidth } from '@fs/zion-ui'

/**
 * @param {object} props
 * @param {'family'|'research-tree'} props.subPage
 * @returns {JSX.Element}
 */

export default function GroupDetailsPageSkeletons({ subPage }) {
  const atPageWidth = usePageWidth()
  const isMobile = atPageWidth({ default: true, lg: false })
  return (
    <>
      <LayoutBand maxWidth={subPage === 'family' ? 'xl' : 'md'} color={colors.gray00}>
        <Separator />
        {/* eslint-disable-next-line test-selectors/button -- loading skeleton */}
        {isMobile && <Skeleton.Button maxWidth={160} />}
        <Separator />
        <Grid>
          {!isMobile && (
            <div columns={2}>
              {/* eslint-disable-next-line test-selectors/button -- loading skeleton */}
              <Skeleton.Button maxWidth={160} />
            </div>
          )}
          <Row wrap={isMobile} columns={isMobile ? 12 : 8}>
            <Skeleton.Image height={180} width={240} />
            <div growX>
              <Skeleton.H3 />
              <div style={{ maxWidth: 500 }}>
                <Skeleton.Paragraph lineCount={3} />
              </div>
              {subPage === 'family' && (
                <Row>
                  <Skeleton.Chip minWidth={100} />
                  <Skeleton.Chip minWidth={100} />
                </Row>
              )}
              <Row wrap={isMobile}>
                {/* eslint-disable-next-line test-selectors/button -- It's a loading skeleton */}
                <Skeleton.Button maxWidth={200} minWidth={100} />
                {/* eslint-disable-next-line test-selectors/button -- It's a loading skeleton */}
                <Skeleton.Button maxWidth={200} minWidth={100} />
              </Row>
            </div>
          </Row>
          {!isMobile && <div columns={2} />}
        </Grid>
        <Separator />
      </LayoutBand>

      <LayoutBand color={colors.gray03} growY maxWidth={subPage === 'family' ? 'xl' : 'md'} marginY="xxs" marginX="xxs">
        <Grid gutters="sm">
          <Card columns={isMobile ? 12 : 8} edges="border" backgroundColor={colors.gray00} growX margins="xs">
            <Skeleton.H3 />
            <Skeleton.ListItem hasIcon />
            <Skeleton.ListItem hasIcon />
            <Skeleton.ListItem hasIcon />
            <Skeleton.ListItem hasIcon />
          </Card>
          {!isMobile && (
            <div columns={4}>
              <Skeleton.H3 />
              <Skeleton.ListItem hasIcon />
              <Skeleton.ListItem hasIcon />
              <Skeleton.ListItem hasIcon />
              <Skeleton.ListItem hasIcon />
            </div>
          )}
        </Grid>
      </LayoutBand>
    </>
  )
}
